import React, { useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as actions from '../../../_redux/bank-kurban/bankKurbanAction';
import { BankKurbanForm } from './BankKurbanForm';
import { useBankKurbanUIContext } from '../BankKurbanUIContext';

import { toast } from 'react-toastify';
import { toastOption } from '../../../../../../_metronic/_helpers';

export function BankKurbanDialog({ id, show, onHide }) {

    const bankKurbanUIContext = useBankKurbanUIContext();
    const bankKurbanUIProps = useMemo(() => {
        return {
            queryParams: bankKurbanUIContext.queryParams,
            setQueryParams: bankKurbanUIContext.setQueryParams,
            openProcessPage: bankKurbanUIContext.openProcessPage,
        };
    }, [bankKurbanUIContext]);

    // Redux
    const dispatch = useDispatch();

    const saveUpload = (value) => {
        const formData = new FormData();
        formData.append('file', value.file);
        formData.append('channel_uuid', value.channel_uuid);
        formData.append('type', 'KURBAN');
        formData.append('department_uuid', value.department_uuid)

        dispatch(actions.uploadfile(formData)).then(response => {
            if (response !== undefined) {
                toast.success(response.message, toastOption);
            }
            onHide();
            bankKurbanUIProps.openProcessPage(response.data.uuid)
            // dispatch(actions.fetchBankKurban(bankKurbanUIProps.queryParams)).then(() => {
            //     onHide();
            // });
        });
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="modal-upload-bank">
            <Modal.Header closeButton>
                <Modal.Title>Upload Bank File</Modal.Title>
            </Modal.Header>

            <BankKurbanForm
                onHide={onHide}
                saveUpload={saveUpload}
            />
        </Modal>
    );
};

